<template>
    <b-form @keydown="item.onKeydown($event)" @submit.prevent="handleSave">
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-body>
            <fieldset>
                <b-form-group
                    :invalid-feedback="item.errors.get('staff_members')"
                    :label="$t('Staff members')"
                    :state="item.errors.has('staff_members') ? false : null"
                    label-for="staff_members"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="staff_members"
                        v-model="item.staff_members"
                        :resource="`staff_members?role=${STAFF_MEMBER_ROLES.STAFF_MEMBER}`"
                        :state="item.errors.has('staff_members') ? false : null"
                        multiple
                        name="staff_members"
                    />
                    <b-input
                        v-else
                        :value="(item.staff_members || []).map(({name}) => name).join(', ')"
                        readonly
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('agency_workers')"
                    :label="$t('Agency workers')"
                    :state="item.errors.has('agency_workers') ? false : null"
                    label-for="agency_workers"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="agency_workers"
                        v-model="item.agency_workers"
                        :resource="`staff_members?role=${STAFF_MEMBER_ROLES.AGENCY_WORKER}`"
                        :state="item.errors.has('agency_workers') ? false : null"
                        multiple
                        name="agency_workers"
                    />
                    <b-input
                        v-else
                        :value="(item.agency_workers || []).map(({name}) => name).join(', ')"
                        readonly
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('subcontractors')"
                    :label="$t('Subcontractors')"
                    :state="item.errors.has('subcontractors') ? false : null"
                    label-for="subcontractors"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="subcontractors"
                        v-model="item.subcontractors"
                        :resource="`staff_members?role=${STAFF_MEMBER_ROLES.SUBCONTRACTOR}`"
                        :state="item.errors.has('subcontractors') ? false : null"
                        multiple
                        name="subcontractors"
                    />
                    <b-input
                        v-else
                        :value="(item.subcontractors || []).map(({name}) => name).join(', ')"
                        readonly
                    />
                </b-form-group>
            </fieldset>
        </b-card-body>

        <b-card-footer v-if="$gate.allow('update',item)">
            <b-button
                :disabled="item.busy"
                trasition="fade"
                type="submit"
                variant="primary"
            >
                {{ project ? $t('Save'): $t('Create') }}
                <b-spinner v-show="item.busy" small />
            </b-button>
        </b-card-footer>
</b-form>
</template>

<script>
    import Form from 'vform'
    import itemMixin from "@/mixins/itemMixin";
    import {STAFF_MEMBER_ROLES} from "@/constants";
    import ResourceSelect from "@/components/selects/ResourceSelect";

    export default {
        name: 'ProjectPlanning',
        components: {
            ResourceSelect,
        },
        mixins: [itemMixin],
        props: {
            project: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                lazy: true,
                item: new Form({
                    model_name: 'project',
                    staff_members: [],
                    agency_workers: [],
                    subcontractors: []
                }),
                disabilitiesForm: new Form(),
                STAFF_MEMBER_ROLES,
            }
        },
        computed: {
            resourceName() {
                return 'projects';
            },
        },

        watch: {
            project: {
                handler(newProjectValue) {
                    this.setData(newProjectValue);
                },
                immediate: true
            }
        },

        methods: {
            setData(data) {
                let defaults = {
                    model_name: 'project',
                    staff_members: [],
                    agency_workers: [],
                    subcontractors: []
                };


                this.item = new Form(Object.assign(defaults, data))
            },
        },
    }
</script>
